const API_URL_ENV = process.env.REACT_APP_API_URL || ""
export const API_URL = API_URL_ENV.replace(/\/+$/, "")
export const EDITOR_KEY = process.env.REACT_APP_EDITOR_KEY
export const ALLOWED_APP = process.env.REACT_APP_ALLOWED_APP ||""
export const JWT_SECRET = '123456' ;
const AUTH_REQUIRED_ENV = process.env.REACT_APP_REQUIRE_AUTH || "false"
const SIDEBAR_ENABLED_ENV = process.env.REACT_APP_ENABLE_SIDEBAR || "true"
export const IS_AUTH_REQUIRED = AUTH_REQUIRED_ENV.toLowerCase() === "true"
export const IS_SIDEBAR_ENABLED = SIDEBAR_ENABLED_ENV.toLowerCase() === "true"
